import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./CarCard.css";
import { FaPhoneAlt } from "react-icons/fa";
import { MyContext } from "../Context/MyContext";
import { resolveImage } from "../../Utils/imageUtils";
import CarActionButtons from "./CarActionButtons";

export default function CarCard({ car, onCall }) {
  const { brands, model, fuel_type, transmission, seats, featuers } =
    useContext(MyContext);
  const navigate = useNavigate();

  const getBrandName = (id) => brands.find((b) => b.id === id)?.name || "-";
  const getModelName = (id) => model.find((m) => m.id === id)?.name || "-";
  const getFuelTypeName = (id) => fuel_type.find((f) => f.id === id)?.name || "-";
  const getTransmissionName = (id) =>
    transmission.find((t) => t.id === id)?.name || "-";
  const getSeatsName = (id) => seats.find((s) => s.id === id)?.name || "-";

  const featureNames = (car.feature_ids || [])
    .map((id) => featuers.find((f) => f.id === id)?.name || "")
    .filter(Boolean);

  return (
    <div className="car-card">
      <div className="car-image-wrap">
        <CarActionButtons car={car} variant="card" />
        <img
          src={resolveImage(car.images?.[0])}
          alt="car"
          className="car-image"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = resolveImage(null);
          }}
        />
        {featureNames.length > 0 && (
          <div className="car-features-overlay">
            {featureNames.map((name) => (
              <span key={name} className="feature-tag">
                {name}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="car-info-section">
        <h3 className="car-title">
          {car.year} {getBrandName(car.brand_id)} {getModelName(car.model_id)}
        </h3>

        <div className="car-specs">
          <span>{car.km_driven?.toLocaleString()} km</span>
          <span>{getFuelTypeName(car.fuel_type_id)}</span>
          <span>{getTransmissionName(car.transmission_id)}</span>
        </div>

        <div className="price-row">
          <div className="emi">{getSeatsName(car.seats_id)}</div>
          <div className="price-section">
            <span className="new-price">₹{car.price?.toLocaleString()}</span>
          </div>
        </div>

        <div className="car-location">📍 {car.location}</div>
      </div>

      <div className="car-actions">
        <button type="button" className="btn-call" onClick={() => onCall(car)}>
          <FaPhoneAlt className="btn-icon" /> Get Call
        </button>
        <button
          type="button"
          className="btn-details"
          onClick={() => navigate(`/car/${car.id}`)}
        >
          More Details
        </button>
      </div>
    </div>
  );
}
